import React from "react";

import Select from "react-select";
import * as SC from "./DarkSelect.styled";

const dot = (color = "transparent") => ({
  alignItems: "center",
  display: "flex",

  ":before": {
    backgroundColor: color,
    borderRadius: 10,
    content: '" "',
    display: "block",
    marginRight: 8,
    height: 10,
    width: 10
  }
});

const colourStyles = {
  control: () => SC.SelectorControl,
  option: (styles) => ({ ...styles, color: "white" }),
  input: (styles) => ({ ...styles, ...dot(), color: "white" }),
  placeholder: (styles) => ({ ...styles, ...dot("#ccc"), color: "white" }),
  singleValue: (styles, { data }) => ({ ...styles, ...dot(data.color), color: "white" }),
  dropdownIndicator: (styles) => ({ ...styles, padding: 0, color: "#4056F4" }),
  valueContainer: (styles) => ({ ...styles, padding: 0, color: "white" }),
  menuList: (styles) => ({ ...styles, backgroundColor: "#232459", color: "white" }),
  noOptionsMessage: (styles) => ({ ...styles, color: "white" })
};

const DarkSelect = ({ options = [], value = "", onChange = void 0 }) => {
  return (
    <Select
      styles={colourStyles}
      options={options}
      value={value}
      onChange={onChange}
      isSearchable={false}
    />
  );
};

export default DarkSelect;
